define('module/logo-grid',[
    'jquery',
    'underscore',
    'cnf',
    '_pubsub'
], function($,_,Cnf, Pubsub) {
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub();
        
        this.options={
            delay:3.5,
            selector:{
                trigger:'.trigger-logo-grid',
                item:'.logo-item'
            },
            data:{
                active:'active',
                zindex:'zindex',
                viewport:'viewport'
            },
            clickNS:'click.logogrid'
        };
        
        this.init=function()
        {
            this.initOptions();
            this.initEvents();
            this.initFade();
        };
        
        this.initOptions=function()
        {
            this.oLogoGrid={};
            this.oInterval={};
            this.$logogrid=Cnf.$app.find(this.options.selector.trigger);
            this.iLogoGrid=this.$logogrid.length;
        };
        
        this.initEvents=function()
        {
            oPubsub.on(Pubsub.VIEWPORT_CHANGE,_.bind(this.onViewportChange,this));
        };
        
        this.initFade=function()
        {
            if(this.iLogoGrid<=0) {
                return;
            }
            
            var $item;
            
            for(var i=0;i<this.iLogoGrid;i++) {
                $item=this.$logogrid.eq(i).find(this.options.selector.item);
                
                this.oLogoGrid[i]={
                    current:0,
                    viewport:this.$logogrid.eq(i).data(this.options.data.viewport),
                    active:false,
                    $grid:this.$logogrid.eq(i),
                    $item:$item,
                    length:$item.length
                };
            }
            
            this.onViewportChange({
                current:Cnf.viewport
            });
        };
        
        this.startFade=function(index)
        {
            if(true===this.oLogoGrid[index].active) {
                return;
            }
            this.oLogoGrid[index].active=true;
            
            this.oInterval[index]=window.setInterval(_.bind(this.logogridNext,this,index), (this.options.delay *1000));
        };
        
        this.stopFade=function(index)
        {
            if(false===this.oLogoGrid[index].active) {
                return;
            }
            this.oLogoGrid[index].active=false;
            
            window.clearInterval(this.oInterval[index]);
            for(var i=0,y=this.oLogoGrid[index].length;i<y;i++) {
                if(i===0) {
                    this.oLogoGrid[index].$item.eq(i).removeAttr('data-' + this.options.data.zindex);
                    this.oLogoGrid[index].$item.eq(i).attr('data-' + this.options.data.active,'true');
                } else {
                    this.oLogoGrid[index].$item.eq(i).removeAttr('data-' + this.options.data.zindex);
                    this.oLogoGrid[index].$item.eq(i).removeAttr('data-' + this.options.data.active);
                }
            }
        };
        
        this.logogridNext=function(index)
        {
            if(this.oLogoGrid[index].length<=1) {
                return;
            }
            
            //@see FDZ-223: catch click-event for time of transition
            this.oLogoGrid[index].$grid.on(this.options.clickNS, function(ev){
                ev.preventDefault();
                ev.stopPropagation();
            });
            _.delay(_.bind(function(index){
                this.oLogoGrid[index].$grid.off(this.options.clickNS);
            }, this, index),1500);
            
            //A) 2 slides
            if(this.oLogoGrid[index].length===2) {
                //hide the other item
                var iCurrent=(this.oLogoGrid[index].current===0) ? 0 : 1;
                this.oLogoGrid[index].$item.eq(iCurrent).attr('data-' + this.options.data.zindex, 'false');
                _.delay(_.bind(function(index, iCurrent) {
                    this.oLogoGrid[index].$item.eq(iCurrent).attr('data-' + this.options.data.active, 'false');
                },this, index, iCurrent), ((this.options.delay *1000) -300));
                
            //B) more than 2 slides
            } else {
                //hide previous
                var iPrev=this.oLogoGrid[index].current -1;
                if(iPrev<0) {
                    iPrev=this.oLogoGrid[index].length -1;
                }
                this.oLogoGrid[index].$item.eq(iPrev).attr('data-' + this.options.data.active, 'false');

                //reset zindex of current
                this.oLogoGrid[index].$item.eq(this.oLogoGrid[index].current).attr('data-' + this.options.data.zindex, 'false');
            }
            
            //show next
            var iNext=this.oLogoGrid[index].current +1;
            if(iNext>=this.oLogoGrid[index].length) {
                iNext=0;
            }
            this.oLogoGrid[index].$item.eq(iNext).attr('data-' + this.options.data.zindex, 'true')
                    .attr('data-' + this.options.data.active, 'true');
            
            this.oLogoGrid[index].current++;
            if(this.oLogoGrid[index].current>=this.oLogoGrid[index].length) {
                this.oLogoGrid[index].current=0;
            }
        };
        
        /**
         * callback on pubsub viewport change
         * 
         * @param {type} ev
         * @returns {undefined}
         */
        this.onViewportChange=function(ev)
        {
            for(var i=0;i<this.iLogoGrid;i++) {
                if(this.oLogoGrid[i].viewport.indexOf(ev.current)>=0) {
                    this.startFade(i);
                } else {
                    this.stopFade(i);
                }
            }
        };
        
        this.init();
    };
});
